export const sourceContext = [
  {
    contextName: "Offer",
    getUrl: keys => {
      return `/offers/${keys.documentId}/${keys.siteId}`;
    }
  },
  {
    contextName: "Folder",
    getUrl: keys => {
      return `/folders/${keys.documentId}/${keys.siteId}/generalData`;
    }
  },
  {
    contextName: "WLD",
    getUrl: keys => {
      return `/offers/${keys.documentId}/${keys.siteId}`;
    }
  },
  {
    contextName: "WLO",
    getUrl: keys => {
      return `/folders/${keys.documentId}/${keys.siteId}/generalData`;
    }
  }
];
